import { render, staticRenderFns } from "./IndicatorsAll.vue?vue&type=template&id=65e0c68e&scoped=true&"
import script from "./IndicatorsAll.vue?vue&type=script&lang=js&"
export * from "./IndicatorsAll.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsAll.vue?vue&type=style&index=0&id=65e0c68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0c68e",
  null
  
)

export default component.exports